module.exports = __webpack_public_path__ + "static/media/27-7.39ca8389.mp3";